import { Component, Input } from '@angular/core';
import { KpiLegendValue } from '@models';

@Component({
  selector: 'drilldown-toggle-chart-legend',
  templateUrl: './drilldown-toggle-chart-legend.component.html',
  styleUrls: ['./drilldown-toggle-chart-legend.component.scss']
})
export class DrilldownToggleChartLegendComponent {
  @Input() legends: KpiLegendValue[] = [];
  @Input() size: 'small' | 'medium' | 'large' = 'small';
  @Input() isCount = false;

  adjustText(legendText: string) {
    return legendText.length > 20 && this.size === 'small'
      ? legendText.substring(0, 20) + '...'
      : legendText;
  }
}
